import styled from "styled-components";

export const NewPageHeaderStyled = styled.div`
  margin: auto;
  margin-bottom: 30px;
  .title {
    text-align: center;
    margin-bottom: 3px;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S26};
    font-family: ${({ theme }) => theme.FONT.STYLE.GT_AMERICA_COMPRESSED_BOLD};
  }
  .liner {
    margin: auto;
    margin-bottom: 3px;
    width: 50px;
    height: 1px;
    background: ${({ theme }) => theme.COLORS.PURPLE_1};
  }
  .sub_title {
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .title {
      margin-bottom: 5px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
    }
    .liner {
      margin-bottom: 5px;
    }
  }
`;
